  // Footer newsletter

KlaviyoSubscribe.attachToForms("#footer_nl_signup", {
    hide_form_on_success: true,
    custom_success_message: true,
    success: function ($form) {
      window.dataLayer = window.dataLayer || [];
      var email = document.getElementById('k_id_email').value; // Get the email value
      dataLayer.push({
        event: 'custom_events',
        event_name: 'newsletter_sign_up',
        form_type: 'Newsletter',
        form_offer: '33% off your first order',
        email: email // Use the email from the input
      });
      $("#footer_nl_signup .form-wrapper, #footer_nl_signup .optin, #footer_nl_signup > p").hide();
    },
    extra_properties: {
      $source: "Footer Newsletter",
    },
  });

  // Newsletter modal

KlaviyoSubscribe.attachToForms("#footer_nl_signup_b", {
    hide_form_on_success: true,
    custom_success_message: true,
    success: function ($form) {
      window.dataLayer = window.dataLayer || [];
      var email = document.getElementById('k_id_email_B').value; // Get the email value
      dataLayer.push({
        event: 'custom_events',
        event_name: 'newsletter_sign_up',
        form_type: 'Newsletter',
        form_offer: '33% off your first order',
        email: email // Use the email from the input
      });
      console.log(
        {
          event: 'custom_events',
          event_name: 'newsletter_sign_up',
          form_type: 'Newsletter',
          form_offer: '33% off your first order',
          email: email // Use the email from the input
        }
      )
      $(".newsletter-modal .state-one").hide();
      $(".newsletter-modal .state-two").show();
      var email = $("#k_id_email_B").val();
      $("#k_id_email_C").val(email);
    },
    extra_properties: {
        $source: "Newsletter modal",
    },
});

  // Step 2

KlaviyoSubscribe.attachToForms("#footer_nl_signup_c", {
    hide_form_on_success: true,
    custom_success_message: true,
    success: function ($form) {
      $(".j-klavyio-hide-on-success").hide();
      $(".j-klavyio-success-msg").show();
      setTimeout(function () {
        $(".j-close-newsletter").click();
      }, 3000);
    },
    extra_properties: {
      $source: "Newsletter modal - personal",
    },
});

  // Strava Challenge Form

KlaviyoSubscribe.attachToForms("#strava-form-signup", {
    hide_form_on_success: true,
    custom_success_message: true,
    success: function ($form) {
      $("#strava-form-signup .fields").hide();
      if ($("#strava-form-signup").siblings(".results-panel").first().length) {
        $("#strava-form-signup").hide();
        $(".results-panel").first().show();
        $("html,body").animate(
          {
            scrollTop: $(".overview-title-box").first().offset().top - 250,
          },
          1000
        );
      }
    },
    error: function ($form) {
      console.log("error:", $form);
      $("#strava-form-signup .klaviyo_messages .error_message").text($form[0]);
    },
    extra_properties: {
      $source: "Strava Page Form 2021",
    },
});